<script setup lang="ts">
defineProps<{
  title?: string
  progress: number
  message: string
  logs: string[]
  compact?: boolean
}>()
</script>

<template>
  <div class="job-progress execution-progress" :class="{ 'job-progress--compact': compact }">
    <div class="progress-head">
      <strong>{{ title || '执行导入任务' }}</strong>
      <span>{{ progress }}%</span>
    </div>
    <div class="progress-track">
      <div class="progress-bar" :style="{ width: `${progress}%` }"></div>
    </div>
    <div v-if="message" class="small job-progress-message">{{ message }}</div>
    <ul v-if="logs.length">
      <li v-for="(log, index) in logs" :key="`${index}-${log}`">{{ log }}</li>
    </ul>
  </div>
</template>
